import BillyApi from '../../api/BillyApi';
import DDLogs from '../../DDLogs';

const state = {
  pricing: {
    monthly: null,
    annual: null,
    advisory: null,
  },
  offerings: [],
  isLoading: false,
  error: null,
};

const getters = {
  monthlyPrice: state => state.pricing.monthly,
  formattedMonthlyPrice: state => (state.pricing.monthly ? `₪${state.pricing.monthly}` : null),
  formattedAnnualPrice: state => (state.pricing.annual ? `₪${state.pricing.annual}` : null),
};

const actions = {
  async fetchPricing({ commit }) {
    commit('setLoading', true);
    commit('setError', null);

    try {
      const { pricing } = await BillyApi.fetchPricingOption();
      commit('setPricing', pricing);
    } catch (error) {
      commit('setError', error);
      DDLogs.error('Failed to fetch pricing', { error });
    } finally {
      commit('setLoading', false);
    }
  },

  async fetchPricingNoAuth({ commit }) {
    commit('setLoading', true);
    commit('setError', null);

    try {
      const { pricing } = await BillyApi.fetchPricingOptionNoAuth();
      commit('setPricing', pricing);
    } catch (error) {
      commit('setError', error);
      DDLogs.error('Failed to fetch pricing (no-auth)', { error });
    } finally {
      commit('setLoading', false);
    }
  },

  async fetchOfferings({ commit }) {
    try {
      const offerings = await BillyApi.getOfferings();
      commit('setOfferings', offerings);
    } catch (error) {
      DDLogs.error('Failed to fetch offerings', { error });
    }
  },

  async initializePricing({ dispatch }) {
    await Promise.all([
      dispatch('fetchPricing'),
      dispatch('fetchOfferings'),
    ]);
  },

  async initializePricingNoAuth({ dispatch }) {
    await dispatch('fetchPricingNoAuth');
  },
};

const mutations = {
  setPricing(state, pricing) {
    state.pricing = pricing;
  },
  setOfferings(state, offerings) {
    state.offerings = offerings;
  },
  setLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setError(state, error) {
    state.error = error;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
